import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { withIcon } from '../../core/components/Icon.tsx';
import Page from '../../core/components/Page';

const HistoryIcon = withIcon(faClockRotateLeft);

// opens the conversation sidebar drawer on small screens; the sidebar is always visible on larger ones
export const SidebarToggle = ({ onClick }: { onClick: () => void }) => {
    const { t } = useTranslation('chat');
    return (
        <Page.HeaderIconButton
            type="button"
            variant="ghost"
            className="md:hidden"
            aria-label={t('sidebar.history')}
            onClick={onClick}
        >
            <HistoryIcon />
        </Page.HeaderIconButton>
    );
};
